module.exports = __webpack_public_path__ + "img/card3.c6054e7d.png";